// Prefer env in builds; fall back to current dev API
const BASE_URL =
  process.env.REACT_APP_API_URL || "https://dev.api.prontopsy.com/api/v1";
export default BASE_URL;
